module.exports = __webpack_public_path__ + "img/brasao_2.380adeb8.png";